"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));

var _reactGa = require("react-ga");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _brightDates = require("bright-dates");

var _OutlineButton = _interopRequireDefault(require("../../Button/OutlineButton"));

var _BrandButton = _interopRequireDefault(require("../../Button/BrandButton"));

var _LinkButton = _interopRequireDefault(require("../../LinkButton"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _Header = _interopRequireDefault(require("../Header"));

var _dayPickerCSS = _interopRequireDefault(require("./dayPickerCSS"));

var _Shortcuts = _interopRequireDefault(require("../Shortcuts"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n\tjustify-content: flex-end;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tmax-width: 312px;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: ", ";\n\t> * {\n\t\ttext-align: center;\n\t}\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tmargin-bottom: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0 ", ";\n\tpadding: ", " 0;\n\tborder-top: 1px solid ", ";\n\tdisplay: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-left: 4px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var weekdayNames = (0, _brightDates.weekdaysShort)();

var HeaderDayPicker = _styledComponents.default.div(_templateObject(), _dayPickerCSS.default);

HeaderDayPicker.displayName = 'HeaderDayPicker';
var ApplyButton = (0, _styledComponents.default)(_BrandButton.default)(_templateObject2());
ApplyButton.displayName = 'ApplyButton';
var ClearButton = (0, _styledComponents.default)(_OutlineButton.default)(_templateObject3());
ClearButton.displayName = 'ClearButton';

var Footer = _styledComponents.default.div(_templateObject4(), _spacing.default.s3, _spacing.default.s2, _colors.default.grey, function (props) {
  return props.show ? 'block' : 'none';
});

Footer.displayName = 'Footer';
var MonthDisplay = (0, _styledComponents.default)(_LinkButton.default)(_templateObject5());
MonthDisplay.displayName = 'MonthDisplay';
var YearDisplay = (0, _styledComponents.default)(_LinkButton.default)(_templateObject6());
YearDisplay.displayName = 'YearDisplay';

var FooterItems = _styledComponents.default.div(_templateObject7(), _spacing.default.s1);

FooterItems.displayName = 'FooterItems';
var FooterShortcuts = (0, _styledComponents.default)(FooterItems)(_templateObject8(), _spacing.default.s2);
FooterShortcuts.displayName = 'FooterShortcuts';
var FooterActions = (0, _styledComponents.default)(FooterItems)(_templateObject9());
FooterActions.displayName = 'FooterActions';

var HeaderDayPickerPanel =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(HeaderDayPickerPanel, _React$Component);

  function HeaderDayPickerPanel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = HeaderDayPickerPanel.prototype;

  _proto.setMonthYear = function setMonthYear(day) {
    this.props.setMonth((0, _brightDates.date)(day).month());
    this.props.setYear((0, _brightDates.date)(day).year());
  };

  _proto.setDateFromShortcut = function setDateFromShortcut(range) {
    var _this$props = this.props,
        yearRange = _this$props.yearRange,
        onSelectedDay = _this$props.onSelectedDay;
    var maxRange = (0, _brightDates.date)(yearRange.max).endOf('year').endOf('month').startOf('day');
    var minRange = (0, _brightDates.date)(yearRange.min).startOf('month');
    var from = (0, _brightDates.max)((0, _brightDates.min)(range.from, maxRange), minRange);
    var to = (0, _brightDates.min)((0, _brightDates.max)(range.to, minRange), maxRange);

    while (this.isDisabled(from) && from.isBefore((0, _brightDates.max)(to, maxRange))) {
      from = from.add(1, 'day');
    }

    while (this.isDisabled(to) && to.isAfter((0, _brightDates.min)(from, minRange))) {
      to = to.subtract(1, 'day');
    }

    var newRange = {
      from: from.toDate(),
      to: to.toDate()
    };
    this.setMonthYear(newRange.to);
    if (from.isAfter(to)) return;
    onSelectedDay(newRange);
  };

  _proto.isDisabled = function isDisabled(day) {
    var disabledDays = this.props.disabledDays;
    if (!disabledDays.length) return false;
    var isDisabledDay = false;
    isDisabledDay = disabledDays.filter(function (item) {
      return item instanceof Date;
    }).find(function (item) {
      return (0, _brightDates.date)(item).isSame((0, _brightDates.date)(day), 'date');
    });
    if (isDisabledDay) return true;
    var allowedDateRanges = disabledDays.filter(function (item) {
      return Object.prototype.hasOwnProperty.call(item, 'before') || Object.prototype.hasOwnProperty.call(item, 'after');
    });

    for (var i = 0; i < allowedDateRanges.length; i++) {
      var range = allowedDateRanges[i];
      isDisabledDay = !!range.before && (0, _brightDates.date)(day).isBefore((0, _brightDates.date)(range.before));
      if (isDisabledDay) break;
      isDisabledDay = !!range.after && (0, _brightDates.date)(day).isAfter((0, _brightDates.date)(range.after));
      if (isDisabledDay) break;
    }

    var disabledDateRanges = disabledDays.filter(function (item) {
      return Object.prototype.hasOwnProperty.call(item, 'from') && Object.prototype.hasOwnProperty.call(item, 'to');
    });

    for (var _i = 0; _i < disabledDateRanges.length; _i++) {
      var _range = disabledDateRanges[_i];
      isDisabledDay = (0, _brightDates.date)(day).isBetween((0, _brightDates.date)(_range.from), (0, _brightDates.date)(_range.to), null, '[]');

      if (isDisabledDay) {
        break;
      }
    }

    return isDisabledDay;
  };

  _proto.handleDayClick = function handleDayClick(day) {
    if (this.isDisabled(day)) {
      this.setMonthYear(day);
      return;
    }

    var _this$props2 = this.props,
        dateRange = _this$props2.dateRange,
        onSelectedDay = _this$props2.onSelectedDay,
        range = _this$props2.range,
        startDateClicked = _this$props2.startDateClicked;
    var newRange;

    if (startDateClicked) {
      newRange = _reactDayPicker.DateUtils.addDayToRange(day, {
        from: undefined,
        to: range.to
      });
    } else {
      newRange = _reactDayPicker.DateUtils.addDayToRange(day, range);
    }

    if (!dateRange) {
      newRange = {
        from: day,
        to: undefined
      };
    } else if (newRange.to && (0, _brightDates.date)(newRange.from).isAfter((0, _brightDates.date)(newRange.to))) {
      var previousTo = newRange.to;
      newRange.to = newRange.from;
      newRange.from = previousTo;
    }

    this.setMonthYear(day);
    onSelectedDay(newRange);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        month = _this$props3.month,
        year = _this$props3.year,
        disabledDays = _this$props3.disabledDays,
        yearRange = _this$props3.yearRange,
        range = _this$props3.range,
        dateRange = _this$props3.dateRange,
        onApply = _this$props3.onApply,
        onClear = _this$props3.onClear,
        onMonthClick = _this$props3.onMonthClick,
        onYearClick = _this$props3.onYearClick,
        shortcuts = _this$props3.shortcuts,
        GA = _this$props3.GA;
    var maxRange = (0, _brightDates.date)(yearRange.max).endOf('year');
    maxRange.date(maxRange.daysInMonth());
    var minRange = (0, _brightDates.date)(yearRange.min).startOf('month');
    var showNext = !(yearRange.max === year && month === 11);
    var showPrevious = !(yearRange.min === year && month === 0);
    var from = range.from,
        to = range.to;
    var selectedDates = dateRange ? [from, {
      from: from,
      to: to
    }] : from;

    var modifiers = _objectSpread({
      startOfWeek: {
        daysOfWeek: [1]
      },
      endOfWeek: {
        daysOfWeek: [0]
      }
    }, dateRange ? {
      from: from,
      to: to,
      toNotSelected: to ? undefined : from
    } : {
      from: from,
      to: from
    });

    var monthToDisplay = (0, _brightDates.months)(month);
    return _react.default.createElement(HeaderDayPicker, null, _react.default.createElement(_reactDayPicker.default, {
      fromMonth: minRange.toDate(),
      toMonth: maxRange.toDate(),
      month: new Date(year, month),
      showOutsideDays: true,
      enableOutsideDaysClick: true,
      firstDayOfWeek: 1,
      weekdaysShort: weekdayNames,
      selectedDays: selectedDates,
      modifiers: modifiers,
      onDayClick: this.handleDayClick,
      disabledDays: disabledDays,
      navbarElement: function navbarElement(_ref) {
        var onPreviousClick = _ref.onPreviousClick,
            onNextClick = _ref.onNextClick,
            nextMonth = _ref.nextMonth,
            previousMonth = _ref.previousMonth;
        return _react.default.createElement(_Header.default, {
          onNext: function onNext() {
            onNextClick();

            _this2.setMonthYear(nextMonth);

            (0, _reactGa.event)({
              category: GA.category,
              action: GA.actionId + " - Next Month"
            });
          },
          onPrevious: function onPrevious() {
            onPreviousClick();

            _this2.setMonthYear(previousMonth);

            (0, _reactGa.event)({
              category: GA.category,
              action: GA.actionId + " - Previous Month"
            });
          },
          showNext: showNext,
          showPrevious: showPrevious
        }, _react.default.createElement(MonthDisplay, {
          onClick: onMonthClick,
          "data-e2e": "select-month"
        }, monthToDisplay), "\xA0", _react.default.createElement(YearDisplay, {
          onClick: onYearClick,
          "data-e2e": "select-year"
        }, year));
      },
      renderDay: function renderDay(day) {
        return _react.default.createElement("div", {
          className: "DayPicker-Day-Date"
        }, _react.default.createElement("div", {
          className: "DayPicker-Day-Circle"
        }, _react.default.createElement("div", {
          className: "DayPicker-Day-Number"
        }, (0, _brightDates.date)(day).format('D'))));
      }
    }), _react.default.createElement(Footer, {
      show: dateRange && onApply || onClear || shortcuts
    }, _react.default.createElement(FooterShortcuts, null, shortcuts && _react.default.createElement(_Shortcuts.default, {
      set: shortcuts,
      dateRange: dateRange,
      shortcutClicked: this.setDateFromShortcut,
      GA: GA
    })), (dateRange || onClear) && _react.default.createElement(FooterActions, null, onClear && _react.default.createElement(ClearButton, {
      gaAction: GA.actionId + " Day picker clear",
      onClick: onClear
    }, "Clear"), dateRange && onApply && _react.default.createElement(ApplyButton, {
      disabled: !from,
      onClick: onApply
    }, "Apply"))));
  };

  return HeaderDayPickerPanel;
}(_react.default.Component);

HeaderDayPickerPanel.displayName = 'HeaderDayPickerPanel';
HeaderDayPickerPanel.propTypes = {
  month: _propTypes.number.isRequired,
  setMonth: _propTypes.func.isRequired,
  setYear: _propTypes.func.isRequired,
  year: _propTypes.number.isRequired,
  yearRange: (0, _propTypes.shape)({
    min: _propTypes.number.isRequired,
    max: _propTypes.number.isRequired
  }).isRequired,
  range: (0, _propTypes.shape)({
    from: (0, _propTypes.instanceOf)(Date),
    to: (0, _propTypes.instanceOf)(Date)
  }).isRequired,
  dateRange: _propTypes.bool.isRequired,
  startDateClicked: _propTypes.bool.isRequired,
  onApply: _propTypes.func,
  onMonthClick: _propTypes.func,
  onYearClick: _propTypes.func,
  onSelectedDay: _propTypes.func.isRequired,
  onClear: _propTypes.func,
  disabledDays: _propTypes.array,
  // eslint-disable-line react/forbid-prop-types
  shortcuts: (0, _propTypes.oneOf)(['today', 'current', 'last']),
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    actionId: _propTypes.string
  }).isRequired
};
HeaderDayPickerPanel.defaultProps = {
  onMonthClick: undefined,
  onYearClick: undefined,
  disabledDays: [],
  onApply: undefined,
  onClear: undefined,
  shortcuts: undefined
};
var _default = HeaderDayPickerPanel;
exports.default = _default;